module.exports = __webpack_public_path__ + "img/Bohren.b310086c.jpg";